/**
 * Contact form API — Lambda Function URL (POST, no auth).
 * URL is injected at build time via REACT_APP_SUBMIT_CONTACT_URL (see sst.config.ts).
 */

const SUBMIT_CONTACT_URL = process.env.REACT_APP_SUBMIT_CONTACT_URL;

if (!SUBMIT_CONTACT_URL && process.env.NODE_ENV !== 'production') {
  console.warn('REACT_APP_SUBMIT_CONTACT_URL is not set. Contact form submissions will fail.');
}

/**
 * Submit a free consultation request.
 * @param {Object} formData - { firstName, lastName, email, phone, caseType, description, urgency?, consentSms, agreeTerms, agreePrivacy, consentedAt }
 * @returns {Promise<{ success: boolean, message: string }>}
 */
export async function submitContactForm(formData) {
  if (!SUBMIT_CONTACT_URL) {
    throw new Error('Contact form is not configured. Please call us directly.');
  }

  const response = await fetch(SUBMIT_CONTACT_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || 'Unable to submit your request. Please try again or call us.');
  }

  return data;
}
